import sizeSliderTemplate from '../partials/sizeSlider.html';

export function SizeSlider() {
    return {
        scope: {
            min: '=',
            max: '=',
            selectedValue: '=',
        },
        template: sizeSliderTemplate,
    };
}
